export function formatDrfErrors(errors) {
    if (errors === undefined)
        return '';
    return Object.entries(errors)
        .map(([field, errContent]) => {
        if (!Array.isArray(errContent)) {
            errContent = [errContent];
        }
        return `${field.replaceAll('_', ' ')}: ${errContent.join(', ')}`;
    })
        .join(', ');
}
